<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">All Operation Appointments</h1>
          </div>
          <div class="col-sm-2">
            <router-link v-if="hasPermission('operation-appointments create')" style="margin-right: 10px"
              class="btn btn-primary" :to="{ name: 'create-operationServiceDay' }">create</router-link>
            <!-- <router-link class="btn btn-success" :to="{ name: 'deleted-operationServiceDays' }">Deleted
              Appointments</router-link> -->
          </div>
          <!-- <div class="col-sm-2">
            <router-link v-if="hasPermission('operation-service-days create')" style="margin-right: 10px"
              class="btn btn-primary" :to="{ name: 'create-operationServiceDay' }">create</router-link>
            <router-link v-if="hasPermission('operation-service-days get-delete-soft')" class="btn btn-success"
              :to="{ name: 'deleted-operationServiceDays' }">Deleted
              Appointments</router-link>
          </div> -->

        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">

            <div v-if="appointments.length > 0">
              <MyTable :columns="columns" :actions="true">
                <tr v-for="(appointment, index) in appointments" :key="index">
                  <th scope="row">{{ appointment.id }}</th>
                  <!-- <td>{{ appointment.appointment_data.lab_name ?? '' }}</td>
                  <td>{{ appointment.appointment_data.service_name ?? '' }}</td> -->

                  <td>{{ appointment.day ? appointment.day.name_en : '' }}</td>
                  <td>{{ appointment.from + ' - ' + appointment.to }}</td>


                  <!-- <td>{{ lab.service_id ? lab.service_id.name : '' }}</td> -->

                  <td>
                    <button class="me-2 btn btn-danger" v-if="hasPermission('operation-appointments delete')"
                      @click="deleteLab(appointment.id)">
                      Delete
                    </button>
                    <router-link class="btn btn-primary spacing" v-if="hasPermission('operation-appointments update')"
                      :to="{ name: 'edit-operationServiceDay', params: { id: appointment.id } }">
                      Edit
                    </router-link>
                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No Appointments found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import axios from "../../Axios";
import { store } from "../../Store";
import $ from 'jquery'; // Import jQuery
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component

export default {
  name: "AlloperationServiceDays",
  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [], // Store DataTable instance
      appointments: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        // { label: 'Lab Name', key: 'appointment_data.lab_name' },
        // { label: 'Main Service', key: 'appointment_data.service_name' },
        // { label: 'Appointment Type', key: 'appointment_type' },
        { label: 'Day', key: 'appointment_day' },
        { label: 'Hour', key: 'appointment_hour' },
      ],
    };
  },

  async created() {
    this.fetchAppointments();
  },

  computed: {
    hasPermission() {
      return (permission) => store.hasPermission(permission);
    },
    filteredAppointments() {
      if (!this.searchTerm) {
        return this.appointments;
      }
      const term = this.searchTerm.toLowerCase();
      return this.appointments.filter(
        (lab) =>
          lab.name.toLowerCase().includes(term)
      );
    },
  },

  methods: {
    // fetch Appointments
    async fetchAppointments() {
      try {

        const response = await axios.get(
          `/api/admin/operation-service-days/all`
        );
        console.log(response);
        this.appointments = response.data.data;
        console.log(" fetching operation-service-days:", this.appointments);
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching operation-service-days:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    // initializeDataTable() {
    //   this.$nextTick(() => {
    //     if (this.dataTable) {
    //       this.dataTable.destroy(); // Destroy existing DataTable instance if it exists
    //     }
    //     this.dataTable = $('.sample_1').DataTable(); // Initialize DataTable
    //   });
    // },
    deleteLab(id) {
      console.log("delete lab id: ", id);
      axios
        .delete(`/admin/admin/operation-service-day/delete?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchLabs();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

};
</script>
<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>